// ===== Packages =====

import {
    doc,
    getFirestore,
    onSnapshot,
    Unsubscribe,
}                               from 'firebase/firestore';

// ===== Interfaces =====

import {
    IAnnotationEngagementItem,
}                               from '../interfaces';

// ===== Enums =====

import {
    FIRESTORE_COLLECTION,
}                               from '../enums';

const subscribeToAnnotationEngagement = ({
    test,
    annotationId,
    onNext,
}: {
    test: boolean,
    annotationId: string,
    onNext: (annotationEngagement: IAnnotationEngagementItem | null) => void,
}): Unsubscribe => {
    const firestore = getFirestore();
    const collection = test
        ? FIRESTORE_COLLECTION.stagingAnnotationEngagement
        : FIRESTORE_COLLECTION.annotationEngagement;

    return onSnapshot(
        doc(firestore, collection, annotationId),
        (snapshot) => {
            if (!snapshot.exists()) {
                onNext(null);
                return;
            }
            onNext(snapshot.data() as IAnnotationEngagementItem);
        },
        () => onNext(null),
    );
};

export default subscribeToAnnotationEngagement;
